import React from 'react'
import ReactDOM from 'react-dom'
import { MaxContext } from './context'
import { subPageBus } from './event'
import { config } from './preference'

/**
 * 缓存页面的渲染方法
 */
export const cacheSubPages = new Map<string, (instanceId: string) => void>()
/**
 * 缓存页面的渲染实例
 */
export const cachePageInstances = new Map<string, any>()

export function create(
  element: (id?: string) => any,
  pageCode: string,
  parentPageCode: string,
  instance: (ele: () => any, leaf: any, type: string) => React.FunctionComponentElement<any>,
  externalId?: string,
) {
  const instanceId = externalId ?? pageCode

  const App = (props: any) => {
    const { page, pageCode } = props

    return (
      <MaxContext.Provider value={{ pageCode, instanceId }}>
        {instance(() => page, null, 'column')}
      </MaxContext.Provider>
    )
  }

  const target = document.querySelector(parentPageCode ? `div#${parentPageCode}` : '#max-app')
  if (target) {
    if (cachePageInstances.has(instanceId)) {
      const page = cachePageInstances.get(instanceId)
      page.onShow?.()
      if (parentPageCode) {
        setTimeout(() => {
          ReactDOM.render(<App page={page} pageCode={pageCode} />, target)
        }, 100)
      } else {
        ReactDOM.render(<App page={page} pageCode={pageCode} />, target)
      }
    } else {
      const page = element(instanceId)
      if (config.isTopCache || page.props?.isCache) {
        cachePageInstances.set(instanceId, page)
      }
      ReactDOM.render(<App page={page} pageCode={pageCode} />, target)
      setTimeout(() => {
        if (config.isAppSim || page.props?.isCache) page.onShow?.()
      }, 0)
    }
  } else {
    subPageBus.addListener(parentPageCode, () => {
      create(element, pageCode, parentPageCode, instance, instanceId)
      subPageBus.removeListener(pageCode)
    })
  }

  cacheSubPages.set(pageCode, (instanceId: string) => create(element, pageCode, parentPageCode, instance, instanceId))
}
